<template>
  <HistoryTabTemplate
    :items="itemsOrder"
    :loading="loading">
    <div
      v-for="(itemOrder, itemIndex) in itemsOrder"
      :key="`agreement-history-${itemIndex}`"
      :data-qa="`agreement-history-${itemIndex}`">
      <div
        v-if="tenderStatuses && itemOrder.tenderStatus"
        class="flex flex-wrap text-left mb-2">
        <span class="font-size-12 text-uppercase">{{ $t('Purchasing.TenderStatus') }}</span>
        <span
          class="font-size-12 text-uppercase ml-4 bold"
          :data-qa="`agrement-history-agreement-tenderStatus`">
          {{ tenderStatuses[itemOrder.tenderStatus] }}</span>
      </div>
      <sAlert
        v-if="itemOrder.title"
        class="mb-3"
        small>
        {{ itemOrder.title }}
      </sAlert>
      <template v-if="$can('set', 'useCommonAgreements')">
        <template v-for="(state, stateIndex) in itemOrder.state">
          <div
            v-if="itemOrder.isAdditional && $can('set', 'useCommonAgreements')"
            :key="`state-${stateIndex}`"
            class="state-name">
            {{ state.name }}
          </div>
          <AgreementsHistoryItems
            :key="`state-${stateIndex}-items`"
            :mode="mode"
            :value="state.items"/>
        </template>
      </template>
      <template v-else>
        <AgreementsHistoryItems
          :mode="mode"
          :tender-statuses="tenderStatuses"
          :value="itemOrder.agrees"/>
      </template>
      <sDivider
        v-if="itemIndex != items.length -1"
        class="mb-4"/>
    </div>
  </HistoryTabTemplate>
</template>
<script>
import AgreementsHistoryItems from 'components/agreement/AgreementsHistoryItems.vue'
import HistoryTabTemplate from 'components/tenders/tender page/HistoryTabTemplate.vue'
// import SmarttenderApi from '@/api/smarttenderApi'
// const tender_api = new SmarttenderApi()

/**
 * История согласований
 * @vue-prop {Array} items - Данные истории
 */
export default {
  name: 'agreementsHistory',
  data() {
    return {
      tenderStatuses: null,
      itemsOrder: []
    }
  },
  methods: {
    parseNoStageAgreements(item) {
      item.forEach(resultItem => {
        resultItem.agrees = resultItem.agrees.map(
          i => ({...i, dateSort: i.endAgree || i.startAgree})
        )
        resultItem.agrees.sort((a, b) => new Date(a.dateSort).getTime() - new Date(b.dateSort).getTime())
      })
      this.itemsOrder = item
    },
    parseStageAgreements(item) {
      const tenderStatuses = item
        .map(i => ({
          comment: i.comment,
          isAdditional: i.isAdditional,
          tenderStatus: i.tenderStatus,
          state: {}
        }))
      item.forEach((resultItem, resultIndex) => {
        const stateName = resultItem.title || '-'
        resultItem.agreements.forEach((agreementItem) => {
          if (!tenderStatuses[resultIndex].state[stateName]) {
            tenderStatuses[resultIndex].state[stateName] = {
              name: stateName,
              items: []
            }
          }
          tenderStatuses[resultIndex].state[stateName].items.push(agreementItem)
        })
      })
      this.itemsOrder = tenderStatuses
    },
    parseItem(item) {
      if (item && item?.length) {
        const resultItems = this.$_.cloneDeep(item)
        if (this.$can('set', 'useCommonAgreements')) {
          this.parseStageAgreements(resultItems)
        } else {
          this.parseNoStageAgreements(resultItems)
        }
      } else {
        this.itemsOrder = []
      }
    }
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
          this.parseItem(newValue)
        }
      }
    }
  },
  props: {
    items: {
      type: Array
    },
    mode: {
      type: String,
      validator: function (value) {
        return ['small', 'big'].indexOf(value) !== -1
      },
      default: 'small'
    },
    loading: {
      type: Boolean
    },
  },
  async mounted() {
    await this.$store.dispatch('setTenderStatuses')
      .then(response => {
        this.tenderStatuses = response.reduce(
          (obj, item) => Object.assign(obj, { [item.statusCode]: item.title }), {})
      })
  },
  components: {
    HistoryTabTemplate,
    AgreementsHistoryItems
  }
}
</script>
<style scoped>
.state-name {
  display: block;
  text-align: left;
  color: var(--black-color);
  background: var(--v-secondary__green_chosen-base);
  border-radius: 8px;
  padding: 5px 20px;
  margin-bottom: 12px;
}
</style>
